import * as React from 'react';
import { useViewabilityHandler } from '../../viewability/viewabilityHandler';

interface ArticleProps {
    articleStyleClassName: string;
}

export const Article: React.FunctionComponent<ArticleProps> = ({ children, articleStyleClassName }) => {
  const ref = useViewabilityHandler(() => {
    // @ts-ignore
    window.mmClientApi = window.mmClientApi || [];
    // @ts-ignore
    window.mmClientApi.push('analytics', {
      event_category: 'Article',
      event_action: 'article end',
      event_label: '',
    });
  }, 1);
  return (
    <article ref={ref} className={articleStyleClassName}>
      {children}
    </article>
  );
};
